import { Modal, ModalCloseButton, ModalFooter, ModalHeader, ModalTitle } from '@tryhackme/thm-ui-components';
import { faInfoCircle, faLightbulb } from '@fortawesome/pro-regular-svg-icons';
import { StyledHeaderOptionButton, StyledOptionButtonIcon } from '../../tasks-tab.styles';
import { StyledTaskTipContainer, StyledTaskTips, StyledTaskTipsIcon, StyledTipDescription, StyledTipHeading, StyledUnorderedList } from './task-info-modal.styles';
import { GeneralPoints } from './task-info-modal.constants';
export const TaskInfoModal = () => <Modal triggerElement={<StyledHeaderOptionButton variant="outlined" color="secondary">
        <StyledOptionButtonIcon icon={faInfoCircle} />
        Task tips
      </StyledHeaderOptionButton>} data-sentry-element="Modal" data-sentry-component="TaskInfoModal" data-sentry-source-file="task-info-modal.tsx">
    <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="task-info-modal.tsx">
      <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="task-info-modal.tsx">
        <StyledTaskTipsIcon icon={faLightbulb} data-sentry-element="StyledTaskTipsIcon" data-sentry-source-file="task-info-modal.tsx" />
        <StyledTaskTips data-sentry-element="StyledTaskTips" data-sentry-source-file="task-info-modal.tsx">Task tips</StyledTaskTips>
      </ModalTitle>
    </ModalHeader>

    <StyledTipHeading data-sentry-element="StyledTipHeading" data-sentry-source-file="task-info-modal.tsx">General</StyledTipHeading>
    <StyledUnorderedList data-sentry-element="StyledUnorderedList" data-sentry-source-file="task-info-modal.tsx">
      {GeneralPoints.map(point => <li key={point}>
          <StyledTipDescription>{point}</StyledTipDescription>
        </li>)}
    </StyledUnorderedList>

    <StyledTaskTipContainer data-sentry-element="StyledTaskTipContainer" data-sentry-source-file="task-info-modal.tsx">
      <StyledTipHeading data-sentry-element="StyledTipHeading" data-sentry-source-file="task-info-modal.tsx">What is the task objective?</StyledTipHeading>
      <StyledTipDescription data-sentry-element="StyledTipDescription" data-sentry-source-file="task-info-modal.tsx">
        A task&apos;s objective is not shown to the user, but some users can view user reports and easily understand
        what a user has accomplished.
      </StyledTipDescription>
    </StyledTaskTipContainer>

    <StyledTaskTipContainer data-sentry-element="StyledTaskTipContainer" data-sentry-source-file="task-info-modal.tsx">
      <StyledTipHeading data-sentry-element="StyledTipHeading" data-sentry-source-file="task-info-modal.tsx">General</StyledTipHeading>
      <StyledTipDescription data-sentry-element="StyledTipDescription" data-sentry-source-file="task-info-modal.tsx">
        If your task includes a virtual machine, and you want to show it&apos;s IP (in the task description, questions
        or hints) when the machine starts, you can add MACHINE_IP where you want the machines IP to be updated - think
        of it as an IP variable thats populated when a machine starts.
      </StyledTipDescription>
    </StyledTaskTipContainer>

    <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="task-info-modal.tsx">
      <ModalCloseButton data-sentry-element="ModalCloseButton" data-sentry-source-file="task-info-modal.tsx" />
    </ModalFooter>
  </Modal>;